// Main load function
//

import { resolveLocale } from './Helpers/Locale.js';

window.mainLoad = mainLoad;
export async function mainLoad(root = document.body) {
	// Initialize calendar (flatpickr)
	//

	const initCalendar = async (elements, root) => {
		if (typeof elements !== 'undefined' && elements.length) {
			try {
				const [{ Flatpickr }, { Formatter }] = await Promise.all([
					import('./Helpers/Flatpickr.js'),
					import('./Helpers/Formatter.js'),
				]);

				await Flatpickr.initOnElements(elements, (elem) => {
					const $el = $(elem);

					const isInFancybox = $el.closest('.fancybox__container, .fancybox__slide, .gn-fancybox').length > 0;
					let fancyboxRangeConfig = isInFancybox ? { static: true } : {};

					return fancyboxRangeConfig;
				});
			} catch (e) {
				console.warn('Flatpickr failed to load', e);
			}
		}
	}

	const calendarItems = initCalendar($('.flatpickr', root));


	// Accordion
	//

	let Accordion;
	try {
		// Pre-check for accordions before importing
		const hasGenericAccordions = $('.articleaccordion, .accordion-container', root).length > 0
			|| $('.articleaccordion .accordion-item, .accordion-container .accordion-item', root).length > 0;
		const hasBpAccordions = bp ? ($('.accordion-container-' + bp, root).length > 0
			|| $('.accordion-container-' + bp + ' .accordion-item', root).length > 0) : false;

		if (hasGenericAccordions || hasBpAccordions) {
			({ Accordion } = await import('./Classes/Accordion.js'));
			// Initial init for generic accordions (only if present)
			if (hasGenericAccordions) {
				Accordion.init($('.articleaccordion, .accordion-container', document));
			}
			// Initial init for current breakpoint-specific containers (only if present)
			if (bp && hasBpAccordions) {
				Accordion.init('.accordion-container-' + bp);
			}
			// Handle reinitialization on breakpoint changes
			let lastAppliedBreakpoint = window.breakpoint;
			let resizeTimer;
			window.addEventListener('resize', function () {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(function () {
					// detectBreakpoint() is called elsewhere and updates window.breakpoint
					const current = window.breakpoint;
					if (!current) return;
					if (current !== lastAppliedBreakpoint) {
						const list = (window.breakpoints && Array.isArray(window.breakpoints)) ? window.breakpoints : ['xs','sm','md','lg','xl','xxl'];
						list.forEach(function (bpName) {
							if (bpName !== current) {
								Accordion.destroy('.accordion-container-' + bpName);
							}
						});
						// Only init if there are containers for the new breakpoint
						const hasCurrentBp = $('.accordion-container-' + current, document).length > 0
							|| $('.accordion-container-' + current + ' .accordion-item', document).length > 0;
						if (hasCurrentBp) {
							Accordion.init('.accordion-container-' + current);
							lastAppliedBreakpoint = current;
						} else {
							lastAppliedBreakpoint = current;
						}
					}
				}, 150);
			});
		}
	} catch (e) {
		// Fail silently if module cannot be loaded
	}


	// Fancybox
	//

	const initFancybox = (box = root) => {
		if (typeof Fancybox !== 'undefined') {
			const resolveParentEl = (instance) => {
				const triggerEl = instance.getOptions().triggerEl;
				if (!triggerEl) return document.body;

				let parentEl =
					triggerEl.closest('.fancybox-container') ||
					(triggerEl.matches('.fancybox-container') ? el : null) ||
					document.body;

				const src = triggerEl.getAttribute('data-src');
				if (src && src.startsWith('#')) {
					const target = document.querySelector(src);
					if (target) {
						const targetContainer =
							target.closest('.fancybox-container') ||
							(target.matches('.fancybox-container') ? target : null);
						if (targetContainer) {
							parentEl = targetContainer;
						}
					}
				}

				return parentEl;
			};

			const locale = resolveLocale(['de', 'it']);
			const l10nMap = {
				de: Fancybox?.l10n?.de_DE,
				it: Fancybox?.l10n?.it_IT,
			};

			const defaultSettings = {
				theme: "light",
				mainClass: "gn-fancybox",
				parentEl: resolveParentEl,
				dragToClose: (instance) => {
					const slide = instance?.getSlide?.();
					return slide?.type !== 'html';
				},
				Carousel: {
					gestures: (ref) => {
						return (typeof ref?.getSlides === 'function' ? ref.getSlides().length : 0) > 1;
					},
					Thumbs: {
						type: 'classic',
					},
					Video: {
						autoplay: false,
					}
				},
				on: {
					// General ready method
					"Carousel.ready": function (instance) {
						try {
							const slide = instance?.getSlide?.();
							const el = slide?.el;

							if (!el) {
								return;
							}

							// Remove f-html class on original for clone type
							//

							const triggerEl = instance?.getOptions?.()?.triggerEl;
							const isClone = triggerEl?.getAttribute?.('data-type') === 'clone';
							if (isClone && typeof slide?.src === 'string' && slide.src.startsWith('#')) {
								document.querySelector(slide.src)?.classList.remove('f-html');

								// Thumbnail-slider
								//

								import('./Helpers/SwiperCloneHelper.js').then(({ SwiperCloneHelper }) => {
									SwiperCloneHelper.reset(el);

									if (typeof window.initThumbnailSlider === 'function') {
										$('.thumbnail-slider', el).each(function () {
											window.initThumbnailSlider($(this));
										});
									}
								});
							}

							// Add scroll event listener
							//

							el.addEventListener('scroll', function (e) {
								const scrollPosition = $(el).scrollTop();
								$(el).css('--scroll-position', `${scrollPosition}px`);
							});

							// Set custom trigger
							//

							const htmlEl = slide?.htmlEl;
							if (htmlEl) {
								$(htmlEl).trigger('fancybox:ready');
							}

							// Additional close button
							//

							el.querySelectorAll('.fb-close').forEach(function (closeBtn) {
								closeBtn.addEventListener('click', function (e) {
									e.preventDefault();
									instance.close();
								});
							});

							// Blazy revalidate
							//

							if (typeof window.bLazy?.revalidate === 'function') {
								window.bLazy.revalidate();
							}

							// Init calendar (flatpickr)
							//

							const calendarItems = initCalendar($('.flatpickr', el));

							// Init fancybox
							//

							initFancybox(el);
						} catch (e) {
							//console.warn('Fancybox ready hook failed', e);
						}
					},
					destroy: function (instance) {
						try {
							const slide = instance?.getSlide?.();

							if (typeof slide?.src === 'string' && slide.src.startsWith('#')) {
								document.querySelector(slide.src)?.classList.remove('f-html');
							}

							const htmlEl = slide?.htmlEl;
							if (htmlEl) {
								htmlEl.classList.remove('f-html');
							}
						} catch (e) {
							//console.warn('Fancybox destroy hook failed', e);
						}
					},
				},
				l10n: l10nMap[locale],
			}

			const fancybox = box.querySelectorAll('[rel^=lightbox], [data-fancybox]:not([data-type="ajax-json"]), .fancybox, .lightbox');
			if (typeof fancybox !== 'undefined' && fancybox.length) {
				const settings = {
					...defaultSettings,
				};

				Fancybox.bind(fancybox, settings);
			}

			// Ajax json fancybox
			const ajaxJsonFancybox = box.querySelectorAll('[data-fancybox][data-type="ajax-json"]');
			if (typeof ajaxJsonFancybox !== 'undefined' && ajaxJsonFancybox.length) {
				ajaxJsonFancybox.forEach(function (el) {
					el.addEventListener('click', async (e) => {
						e.preventDefault();

						const url = el.getAttribute("data-src") || el.getAttribute("href");
						if (!url) return;

						try {
							const res = await fetch(url, {
								mode: 'cors', // no-cors, *cors, same-origin
								credentials: 'include', // include, *same-origin, omit
								redirect: 'follow', // manual, *follow, error
								referrerPolicy: 'no-referrer-when-downgrade', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
								headers: {
									Accept: "application/json"
								}
							});
							if (!res.ok) throw new Error(`HTTP ${res.status}`);

							const data = await res.json();

							if (!data.html) return;
							const html = data.html;

							// optional: Loading direkt öffnen
							// Store InlineDetachMover instances for cleanup
							let detachMoverInstances = [];

							const settings = {
								...defaultSettings,
								on: {
									"Carousel.ready": function (instance) {
										const slide = instance?.getSlide?.();
										const el = slide?.el;

										if (!el) {
											return;
										}


										// Add scroll event listener
										//

										el.addEventListener('scroll', function (e) {
											const scrollPosition = $(el).scrollTop();
											$(el).css('--scroll-position', `${scrollPosition}px`);
										});


										// Set custom trigger
										//

										const htmlEl = slide?.htmlEl;
										if (htmlEl) {
											$(htmlEl).trigger('fancybox:ready');
										}

										// Additional close button
										//

										el.querySelectorAll('.fb-close').forEach(function (closeBtn) {
											closeBtn.addEventListener('click', function (e) {
												e.preventDefault();
												instance.close();
											});
										});

										// Detach page content
										//
										const detachElements = el.querySelectorAll('[data-detatch-mover], .detatch-mover');
										if (typeof detachElements !== 'undefined' && detachElements.length) {
											(async () => {
												try {
													const { InlineDetachMover } = await import('./Classes/InlineDetachMover.js');
													detachMoverInstances = InlineDetachMover.bind(detachElements, {sourceContext: document.body});
												} catch (e) {
													// Fail silently if module cannot be loaded
													console.warn('InlineDetachMover failed to load', e);
												}
											})();
										}

										// Blazy revalidate
										//

										if (typeof window.bLazy?.revalidate === 'function') {
											window.bLazy.revalidate();

											// @todo: not so ideal, but also a new instance is'n it
											el.addEventListener('scroll', function () {
												window.bLazy.revalidate();
											});

											el.querySelectorAll('.scrollcontainer').forEach(function (elem) {
												elem.addEventListener('scroll', function () {
													if (typeof window.bLazy?.revalidate === 'function') {
														window.bLazy.revalidate();
													}
												}, passiveSupport() ? { passive: true } : false);
											});
										}

										// Init/open accordion
										//

										if (typeof Accordion !== 'undefined' && Accordion && container) {
											const accordion = $(el).find('.articleaccordion, .accordion-container, [class*="accordion-container-"]');

											const uninitializedAccordions = accordion.filter(function () {
												return $(this).find('.accordion-item:not(.accordion-initialized)').length > 0;
											});
											if (typeof uninitializedAccordions !== 'undefined' && uninitializedAccordions.length) {
												Accordion.init(uninitializedAccordions, true);
											}
										}

										// Init calendar (flatpickr)
										//

										const calendarItems = initCalendar($('.flatpickr', el));

										// Init tabs
										//

										if ($('.tabs-container', el).length > 0 && typeof initTabs !== 'undefined' && initTabs) {
											initTabs($('.tabs-container', el));

											// Init tab navigation slider

											if ($('.tabs-navigation:has(.swiper-container)', el).length > 0 && typeof initTabNavigationSlider !== 'undefined' && initTabNavigationSlider) {
												$('.tabs-navigation:has(.swiper-container)', el).each(function () {
													initTabNavigationSlider($(this));
												})
											}
										}


										// search for javascripts in modal and execute them
										const scripts = $(el).get(0).querySelectorAll('script');
										scripts.forEach((oldScript) => {
											const newScript = document.createElement('script');
											Array.from(oldScript.attributes).forEach((attr) => {
												newScript.setAttribute(attr.name, attr.value);
											});
											newScript.appendChild(document.createTextNode(oldScript.innerHTML));
											oldScript.parentNode.replaceChild(newScript, oldScript);
										});

										// Init fancybox
										//

										initFancybox(el);
									},
									"Carousel.destroy": function (instance) {
										// Restore detached instances
										//
										if (detachMoverInstances && detachMoverInstances.length) {
											detachMoverInstances.forEach(moverInstance => {
												if (moverInstance && typeof moverInstance.destroy === 'function') {
													moverInstance.destroy();
												}
											});
											detachMoverInstances = [];
										}
									}
								}
							};

							Fancybox.show(
								[{
									type: "html",
									html: html
								}],
								settings,
							);
						} catch (e) {
							// Fail silently
							console.warn('Error loading json data for fancybox', e);
						}
					});
				});
			}
		}
	}

	initFancybox(root);

	// Tooltip
	//
	const tooltipTriggerList = root.querySelectorAll('[data-bs-toggle="tooltip"]');
	if (typeof tooltipTriggerList !== 'undefined' && tooltipTriggerList.length) {
		// Initialize Bootstrap tooltip if available (defensive, no-op if Bootstrap JS not loaded)
		try {
			if (typeof window.bootstrap !== 'undefined' && typeof window.bootstrap.Tooltip !== 'undefined') {
				const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl, {
					html: true,
					delay: {
						show: 300,
						hide: 0
					}
				}));
			}
		} catch (e) {
			/* ignore tooltip init errors */
		}
	}


	// Popover
	//
	const popoverTriggerList = root.querySelectorAll('[data-bs-toggle="popover"]');
	if (typeof popoverTriggerList !== 'undefined' && popoverTriggerList.length) {
		// Initialize Bootstrap popover if available (defensive, no-op if Bootstrap JS not loaded)
		try {
			if (typeof window.bootstrap !== 'undefined' && typeof window.bootstrap.Popover !== 'undefined') {
				const popoverList = [...popoverTriggerList].forEach((el) => {
					const containerEl = el.closest('.fullscreen') || 'body';
					new window.bootstrap.Popover(el, {
						html: true,
						delay: {
							show: 300,
							hide: 0
						},
						container: containerEl,
						template: '<div class="popover" role="tooltip">' +
							'	<div class="popover-arrow"></div>' +
							'	<strong class="popover-header d-block"></strong>' +
							'	<div class="popover-body"></div>' +
							'</div>',
					});
				});
			}
		} catch (e) {
			/* ignore tooltip init errors */
		}
	}

	// Blazy revalidate
	if (typeof window.bLazy?.revalidate === 'function') {
		window.bLazy.revalidate();
	}
}

$(function () {
	void mainLoad();
});

// General async function
//

$(async function () {
});
